import axios from "axios";
import crypto from "crypto";
import { sha256 } from 'js-sha256';
import router from "next/router";
import { trackEvent } from "../../utils/FunctionsGlobals";
export const trackLead = (site: any, property: any) => {
const user = JSON.parse(localStorage.getItem("user") || "{}");
const getCookie = (name: string) =>
    document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
?.split('=')[1] || ''

const hashId = user?.id_client ? crypto.createHash("sha256").update(user.id_client.toString()).digest("hex") : "";
                    
// Normalização dos dados
const normalizedName = user.name ? user.name.trim().toLowerCase() : "";
const normalizedEmail = user.email? user.email.trim().toLowerCase() : "";
const normalizedPhone = user.telephone ? user.telephone.replace(/\D/g, '') : ""; // Apenas números

const hashNome = sha256(normalizedName);
const hashEmail = sha256(normalizedEmail);
const hashTelefone = sha256(normalizedPhone);

if (site?.fb_token_pixel && site?.fb_id_pixel && property?.id) {
    // Definições do Facebook Pixel
    // Hash dos dados
   
    const fbc = getCookie('_fbc')
    const fbp = getCookie('_fbp')
    const accessToken = site.fb_token_pixel;
    const pixelId = site.fb_id_pixel;
    const currentTimestampInSeconds = Math.floor(Date.now() / 1000);

    // Dados do evento Lead (usando as informações do imóvel)

    const eventData = [
        {
        event_name: 'Lead',
        event_time: currentTimestampInSeconds,
        action_source: 'website',
        event_source_url: 'https://' + site?.site,
        user_data: {
            fn: [hashNome],
            em: [hashEmail],
            ph: [hashTelefone],
            fbc: fbc || undefined,
            external_id: hashId ? [hashId] : [], 
            fbp: fbp || undefined
        },custom_data: {
          content_name: property?.titulo || "Imóvel",
          content_category: property?.categoria?.nome || "Imóveis",
          content_ids: [property?.id || "N/A"],
          content_type: "home_listing",
          currency: "BRL",
          value: property?.preco_venda || 0,
        },
    }];

    axios.post(
        `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
        { data: eventData }
    )
        .then(response => {
        console.log('Evento registrado com sucesso:', response.data);
        })
        .catch(error => {
        console.error('Erro ao registrar evento:', error?.response?.data || error.message);
    });
} else {
    console.warn("⚠️ Dados insuficientes para registrar o evento Lead.");
}

    if (site?.pixel_facebook_head && property?.id) {
        // Script Pixel do Facebook
        const listPixelFacebook = site.pixel_facebook_head.match(/init(.*?);/g) || [];
        const pixelFacebook = (listPixelFacebook[0] || '')?.split("init', '");
        const pixelFacebookId = (pixelFacebook[1] || '')?.replace("');", '');

        // Importa o ReactPixel dinamicamente
        import('react-facebook-pixel')
            .then((x) => x.default)
            .then((ReactPixel) => {
            ReactPixel.init(pixelFacebookId);
            ReactPixel.pageView(); // Registra a visualização de página

            router.events.on('routeChangeComplete', () => {
                ReactPixel.pageView();
            });

            // 🔥 Função para registrar um Lead com informações do usuário e do imóvel
            const trackLead = () => {
                ReactPixel.track("Lead", {
                    content_name: property?.titulo || "Imóvel",
                    content_category: property?.categoria?.nome || "Imóveis",
                    content_ids: [property?.id || "N/A"],
                    content_type: "home_listing",
                    currency: "BRL",
                    value: property?.preco_venda || 0,
                    action_source: "website",
                    event_source_url: window.location.href,
                    user_data: {
                        fn: hashNome ? [hashNome] : [],
                        ph: hashTelefone ? [hashTelefone] : [],
                        em: hashEmail ? [hashEmail] : [],
                        external_id: hashId ? [hashId] : [],
                    },
                });
                console.log("✅ Lead registrado no Facebook Pixel com sucesso!");
            };

            // 🔹 Se houver um imóvel e ID disponível, registra o Lead automaticamente
            if (property?.id) {
                trackLead();
            }
        });
    }

    if (site?.tag_google_head || site?.google_analytics_head) {
            const eventData = {
            source: "whatsapp_click"
        };

        trackEvent("whatsapp_click", eventData);
    }
};
